export default "__VITE_ASSET__12dcf45b__"